

import React, {Component } from 'react'
import IRISDownload from './IRISDownload'

export class App extends Component {
  render(){
    return(
      <IRISDownload></IRISDownload>
    )
  }
}
export default App


// import React, {Component } from 'react'
// import firebase from './firebase'

// export class App extends Component {
 
//   handleClick=()=>{
//     var recaptcha=new firebase.auth.RecaptchaVerifier('recaptcha');
//     var number='+919987119373'
//     firebase.auth().signInWithPhoneNumber(number,recaptcha).then(function (e){
//       var code=prompt('Enter the otp','');

//       if(code==null)
//       return

//       e.confirm(code).then(function(result){
//         console.log(result);

//         document.querySelector('lable').textContent+=result.user.phoneNumber+'Number Verified';
        
//       })
//       .catch(function (error){
//         console.log(error)
//       })
//     })

//   }

//   render(){
//     return(
//       <div>
//         <label></label>
//         <div id='recaptcha'>
//         </div>
//         <button onClick={this.handleClick}>Click</button>
//       </div>
//     )
//   }
// }

// export default App

